const BASE_URL = 'https://api.dev.auxo.dk/public';

export async function fetchCollection(collectionName) {
  try {
    const response = await fetch(`${BASE_URL}/content/${collectionName}`);
    if (!response.ok) throw new Error(`Failed to fetch collection: ${collectionName}`);
    return await response.json();
  } catch (error) {
    console.error(error);
    return [];
  }
}

export async function fetchBySlug(lang, slug) {
  try {
    const response = await fetch(`${BASE_URL}/by-slug/${lang}/${slug}`);
    if (!response.ok) throw new Error(`Failed to fetch slug: ${slug}`);
    return await response.json();
  } catch (error) {
    console.error(error);
    return null;
  }
}
